import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {ConsentsFormService} from '../../../../services/consents-form.service';
import {LocalStorageService} from '../../../../services/local-storage.service';

@Component({
  selector: 'app-home-mobile-child-assigned-forms',
  templateUrl: './home-mobile-child-assigned-forms.component.html',
  styleUrls: ['./home-mobile-child-assigned-forms.component.scss']
})
export class HomeMobileChildAssignedFormsComponent implements OnInit, OnChanges {
  @Input() selectedChild: any;
  @Input() mode: any;
  @Output() backButton: EventEmitter<any> = new EventEmitter();
  user: any;
  constructor(private consentsFormService: ConsentsFormService, private localStorageService: LocalStorageService) { }

  ngOnInit(): void {
    this.user = JSON.parse(this.localStorageService.get('user'));
  }

  ngOnChanges(changes: any): void {
    console.log(this.selectedChild);
  }


  back() {
   this.backButton.emit();
  }

  getRecords() {
    if (this.mode !== 'announcement') {
      const records = this.selectedChild.notifications.filter(notification => notification.mode === this.mode);
      return records;
    }
  }
  async showConsent(child, notification: any) {
    if (notification.mode === 'customForm') {
      await this.consentsFormService.showCustomForm(notification, this.user, child);
    } else {
      await this.consentsFormService.showConsent(notification, this.user, child);
    }
  }
}
